import * as React from 'react';
import { css } from '@emotion/core';
import Answer from './Answer';
import LocalDiv from '../../localization/LocalDiv';
import { GoalAnswer } from './models';


const styles = {
  root: css`
  `,
  question: css`
    font-weight: bold;
    margin-bottom: 10px;
  `,
};


type Props = {
  className?: string;
  goalAnswer: GoalAnswer;
  saveAnswer: (answer: string) => void;
  handleClick: () => void;
  handleCancel: () => void;
  inEditMode: boolean;
};


/**
 * Goal: a component that shows a goal and answer
 *
 * PureComponent: true
 * Redux Connected: false
 */
const Goal: React.FC<Props> = props => (
  <LocalDiv css={styles.root}>
    <LocalDiv css={styles.question}>
      {props.goalAnswer.questionText}
    </LocalDiv>
    <Answer
      goalAnswer={props.goalAnswer}
      saveAnswer={props.saveAnswer}
      handleClick={props.handleClick}
      handleCancel={props.handleCancel}
      inEditMode={props.inEditMode}
    /> 
  </LocalDiv>
);

export default Goal;
